import React from 'react';
import { styles } from './styles';
export function GridEmptyBody(_a) {
    var text = _a.text;
    return text ? (React.createElement("div", { className: styles.emptyContainer },
        React.createElement("div", { className: styles.emptyText }, text))) : null;
}
//# sourceMappingURL=GridEmptyBody.js.map